import { render } from "./Logo.vue?vue&type=template&id=fb7acb0e&scoped=true"
import script from "./Logo.vue?vue&type=script&lang=js"
export * from "./Logo.vue?vue&type=script&lang=js"

import "./Logo.vue?vue&type=style&index=0&id=fb7acb0e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fb7acb0e"

export default script